@if (laedt()) {
  <div class="ki-mandant__laedt" role="status" aria-live="polite" data-testid="ki-settings-laedt">
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'settings.ki.laedt' | translate }}</span>
  </div>
} @else if (ladefehler()) {
  <p class="ki-mandant__ladefehler" role="alert" data-testid="ki-settings-ladefehler">
    {{ 'settings.ki.ladefehler' | translate }}
  </p>
} @else {
  <div class="ki-mandant__karte">
    <div class="ki-mandant__karte-inner">
      <div
        class="ki-mandant__hauptschalter"
        [class.ki-mandant__hauptschalter--an]="aktiv()"
        data-ki-abschnitt="hauptschalter"
      >
        <app-ki-mark [size]="30"></app-ki-mark>
        <div class="ki-mandant__hauptschalter-text">
          <div class="ki-mandant__hauptschalter-titel">
            {{ 'settings.ki.hauptschalter.titel' | translate: { firma: firmenname() } }}
          </div>
          <div class="ki-mandant__hauptschalter-untertitel">
            {{ (aktiv() ? 'settings.ki.hauptschalter.an' : 'settings.ki.hauptschalter.aus') | translate }}
          </div>
        </div>
        <app-ki-switch
          testId="ki-settings-hauptschalter"
          [an]="aktiv()"
          [label]="'settings.ki.hauptschalter.label' | translate"
          (geaendert)="onHauptschalter($event)"
        ></app-ki-switch>
      </div>

      <section
        class="ki-mandant__abschnitt"
        [class.ki-mandant__abschnitt--aus]="!aktiv()"
        [attr.aria-disabled]="!aktiv()"
        [attr.inert]="aktiv() ? null : ''"
        data-ki-abschnitt="regionen"
      >
        <div class="ki-mandant__label" id="ki-mandant-regionen">{{ 'settings.ki.abschnitt.regionen' | translate }}</div>
        <div
          class="ki-mandant__regionen"
          role="radiogroup"
          aria-labelledby="ki-mandant-regionen"
          data-testid="ki-settings-region"
        >
          @for (id of regionen; track id; let i = $index) {
            <button
              type="button"
              role="radio"
              class="ki-mandant__region"
              [class.ki-mandant__region--aktiv]="region() === id"
              [attr.aria-checked]="region() === id"
              [attr.data-region]="id"
              [tabIndex]="region() === id ? 0 : -1"
              (click)="onRegion(id)"
              (keydown)="onRegionTaste($event, i)"
            >
              <span class="ki-mandant__region-titel">{{ 'settings.ki.regionen.' + id + '.titel' | translate }}</span>
              <span class="ki-mandant__region-hinweis">
                {{ 'settings.ki.regionen.' + id + '.hinweis' | translate }}
              </span>
            </button>
          }
        </div>
      </section>

      <section
        class="ki-mandant__abschnitt"
        [class.ki-mandant__abschnitt--aus]="!aktiv()"
        [attr.aria-disabled]="!aktiv()"
        [attr.inert]="aktiv() ? null : ''"
        data-ki-abschnitt="anbieter"
      >
        <div class="ki-mandant__label">{{ 'settings.ki.abschnitt.anbieter' | translate }}</div>
        <div class="ki-mandant__liste" data-testid="ki-settings-anbieter">
          @for (a of anbieter; track a.id) {
            @let einstellung = anbieterEinstellung(a.id);
            @let gesperrt = istGesperrt(a.id);
            <div class="ki-mandant__zeile" [attr.data-anbieter]="a.id">
              <div class="ki-mandant__zeile-text">
                <div class="ki-mandant__zeile-titel">{{ 'settings.ki.anbieter.' + a.id | translate }}</div>
                @if (!a.region && einstellung.erlaubt) {
                  <div class="ki-mandant__zeile-untertitel">
                    <input
                      class="ki-mandant__endpunkt"
                      type="text"
                      inputmode="url"
                      spellcheck="false"
                      data-testid="ki-settings-endpunkt"
                      [value]="einstellung.endpunkt ?? ''"
                      [attr.maxlength]="endpunktMax"
                      [placeholder]="'settings.ki.anbieter.endpunktPlatzhalter' | translate"
                      [attr.aria-label]="'settings.ki.anbieter.endpunktLabel' | translate"
                      (input)="onEndpunkt($event)"
                    />
                  </div>
                } @else if (!a.region) {
                  <div class="ki-mandant__zeile-untertitel">
                    {{ 'settings.ki.anbieter.eigenerEndpunkt' | translate }}
                  </div>
                } @else {
                  <div class="ki-mandant__zeile-untertitel">
                    {{
                      'settings.ki.anbieter.herkunft'
                        | translate: { host: a.host, region: 'settings.ki.anbieter.region.' + a.region | translate }
                    }}
                  </div>
                }
              </div>
              <app-ki-switch
                [testId]="'ki-settings-anbieter-' + a.id"
                [an]="einstellung.erlaubt && !gesperrt"
                [disabled]="gesperrt"
                [label]="'settings.ki.anbieter.' + a.id | translate"
                (geaendert)="onAnbieter(a.id, $event)"
              ></app-ki-switch>
            </div>
          }
        </div>
      </section>

      <section
        class="ki-mandant__abschnitt"
        [class.ki-mandant__abschnitt--aus]="!aktiv()"
        [attr.aria-disabled]="!aktiv()"
        [attr.inert]="aktiv() ? null : ''"
        data-ki-abschnitt="funktionen"
      >
        <div class="ki-mandant__label">{{ 'settings.ki.abschnitt.funktionen' | translate }}</div>
        <div class="ki-mandant__liste">
          @for (name of funktionen; track name) {
            <div class="ki-mandant__zeile">
              <div class="ki-mandant__zeile-text">
                <div class="ki-mandant__zeile-titel">{{ 'settings.ki.funktionen.' + name + '.titel' | translate }}</div>
                <div class="ki-mandant__zeile-untertitel">
                  {{ 'settings.ki.funktionen.' + name + '.text' | translate }}
                </div>
              </div>
              <app-ki-switch
                [testId]="'ki-settings-funktion-' + name"
                [an]="funktionAn(name)"
                [label]="'settings.ki.funktionen.' + name + '.label' | translate"
                (geaendert)="onFunktion(name, $event)"
              ></app-ki-switch>
            </div>
          }
        </div>
      </section>

      <section
        class="ki-mandant__abschnitt"
        [class.ki-mandant__abschnitt--aus]="!aktiv()"
        [attr.aria-disabled]="!aktiv()"
        [attr.inert]="aktiv() ? null : ''"
        data-ki-abschnitt="maskierung"
      >
        <div class="ki-mandant__label">{{ 'settings.ki.abschnitt.maskierung' | translate }}</div>
        <app-ki-maskierung
          [muster]="eigeneMuster()"
          [meldungen]="musterMeldungen()"
          (musterGeaendert)="onAenderung({ eigeneMuster: $event })"
        ></app-ki-maskierung>
      </section>

      <section
        class="ki-mandant__abschnitt ki-mandant__raster"
        [class.ki-mandant__abschnitt--aus]="!aktiv()"
        [attr.aria-disabled]="!aktiv()"
        [attr.inert]="aktiv() ? null : ''"
        data-ki-abschnitt="raster"
      >
        <app-ki-raster
          [kontingent]="kontingent()"
          [aufbewahrung]="aufbewahrung()"
          [auditInhalte]="auditInhalte()"
          (aenderung)="onAenderung($event)"
        ></app-ki-raster>
      </section>
    </div>
  </div>

  <section
    class="ki-mandant__abschnitt"
    [class.ki-mandant__abschnitt--aus]="!aktiv()"
    [attr.aria-disabled]="!aktiv()"
    [attr.inert]="aktiv() ? null : ''"
    data-ki-abschnitt="projektuebersicht"
  >
    <app-ki-projektuebersicht></app-ki-projektuebersicht>
  </section>

  <section
    class="ki-mandant__abschnitt"
    [class.ki-mandant__abschnitt--aus]="!aktiv()"
    [attr.aria-disabled]="!aktiv()"
    [attr.inert]="aktiv() ? null : ''"
    data-ki-abschnitt="audit"
  >
    <app-ki-audit-log [inhalteGespeichert]="auditInhalte()"></app-ki-audit-log>
  </section>
}

@if (bestaetigungOffen()) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="ki-mandant__overlay" (click)="onAktivierenAbgebrochen()">
    <div
      class="ki-mandant__dialog"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      aria-labelledby="ki-mandant-dialog-titel"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="$event.stopPropagation()"
      (keydown)="onDialogKeydown($event)"
    >
      <div class="ki-mandant__dialog-kopf">
        <app-ki-mark [size]="26"></app-ki-mark>
        <div id="ki-mandant-dialog-titel" class="ki-mandant__dialog-titel">
          {{ 'settings.ki.bestaetigung.titel' | translate: { firma: firmenname() } }}
        </div>
      </div>
      <div class="ki-mandant__dialog-text">{{ 'settings.ki.bestaetigung.text' | translate }}</div>
      <div class="ki-mandant__dialog-aktionen">
        <button
          mat-stroked-button
          type="button"
          data-testid="ki-settings-aktivieren-abbrechen"
          (click)="onAktivierenAbgebrochen()"
        >
          {{ 'settings.cancel' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          data-testid="ki-settings-aktivieren"
          (click)="onAktivierenBestaetigt()"
        >
          {{ 'settings.ki.bestaetigung.aktivieren' | translate }}
        </button>
      </div>
    </div>
  </div>
}
